/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

export const CategoryRent: FunctionComponent = (): JSX.Element => (
  <React.Fragment>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M7.3978 4.20166C7.64832 4.0127 7.973 3.95228 8.27472 4.03848L22.2747 8.03848C22.704 8.16114 23 8.55353 23 9.00001V20C23 20.5523 22.5523 21 22 21H8H2C1.44772 21 1 20.5523 1 20V14C1 13.6657 1.1671 13.3534 1.4453 13.168L7 9.46483V5.00001C7 4.68622 7.14729 4.39062 7.3978 4.20166ZM21 9.75431V19H18V15C18 14.4477 17.5523 14 17 14H13C12.4477 14 12 14.4477 12 15V19H9V10V6.32574L21 9.75431ZM14 19H16V16H14V19ZM7 11.8685V19H3V14.5352L7 11.8685Z'
      fill='currentColor'
    />
  </React.Fragment>
)
